import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@npm/atlas-css'
import '@/assets/main.css'
import '@vuepic/vue-datepicker/dist/main.css'
import { VueDatePicker } from '@vuepic/vue-datepicker'
import vSelect from 'vue-select'
import App from './App.vue'
import router from './router'
import { setupOfferComponent } from '@/plugins/offer-component'
import { setupVueQuery } from '@/plugins/vue-query'
import { setupI18n } from '@/plugins/i18n'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

setupOfferComponent(app)
setupI18n(app)
setupVueQuery(app)
app.component('VueDatePicker', VueDatePicker)
app.component('v-select', vSelect)

app.mount('#app')
